import { Wheat, AlertTriangle, Fish, Milk, Nut } from "lucide-react";
import type { CategoryKey, RiskLevel, AgeMonths, AllergenKey } from '@/types/ui';

// Food UI constants - centralized styling and configuration

export const CATEGORY_COLORS = {
  'grønnsak': 'hsl(115 65% 60%)', // Green
  'frukt': 'hsl(45 85% 65%)',     // Yellow
  'protein': 'hsl(0 70% 65%)',    // Red
  'korn': 'hsl(30 75% 60%)',      // Orange
  'meieri': 'hsl(210 60% 70%)',   // Blue
  'frø_nøtter': 'hsl(30 50% 50%)', // Brown
  'fat': 'hsl(50 90% 60%)',       // Bright yellow
  'other': 'hsl(0 0% 60%)',       // Gray
} as const;

export const RISK_COLORS = {
  low: "success",
  medium: "warning", 
  high: "destructive",
} as const;

export const AGE_COLORS = {
  4: "bg-gradient-warm",
  6: "bg-gradient-cool",
  8: "bg-gradient-sunset",
  10: "bg-gradient-ocean",
  12: "bg-gradient-purple",
} as const;

export const ALLERGEN_INFO: Record<AllergenKey, { icon: any; label: string }> = {
  gluten: { icon: Wheat, label: 'Gluten' },
  egg: { icon: AlertTriangle, label: 'Egg' },
  milk: { icon: Milk, label: 'Melk' },
  dairy: { icon: Milk, label: 'Melk' },
  nuts: { icon: Nut, label: 'Nøtter' },
  fish: { icon: Fish, label: 'Fisk' },
} as const;
